import { SelectOption } from './../../../../models/select-option.model';
import { UtilsService } from '../../../../services/utils.service';
import { UntypedFormGroup } from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';
import { Province } from 'src/app/models/locality.model';

@Component({
    selector: 'app-address-form',
    templateUrl: './address-form.component.html',
    styleUrls: ['./address-form.component.scss']
})
export class AddressFormComponent implements OnInit {

    formGroupValue: UntypedFormGroup;
    @Input()
    set formGroup(value: UntypedFormGroup) {
        this.formGroupValue = value;
        if (value) {
            this.utilsService.formControlUppercasedFirstLetterOfEveryWord(this.formGroup.controls.calle);
            this.utilsService.formControlUppercasedFirstLetterOfEveryWord(this.formGroup.controls.departamento);
        }
    }
    get formGroup() {
        return this.formGroupValue;
    }

    @Input()
    provinces?: Province[];

    streetTypes: SelectOption[] = [
        { codigo: 'CALLE', descripcion: 'Calle' },
        { codigo: 'AVENIDA', descripcion: 'Avenida' },
        { codigo: 'PASAJE', descripcion: 'Pasaje' },
    ];

    constructor(
        private utilsService: UtilsService
    ) { }

    ngOnInit(): void {
    }
}
